import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge as _merge } from 'lodash-es';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class UserConfigurationService {

  private httpClient: HttpClient = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);
  private readonly languageService = inject(LanguageService);

  refresh() {
    const cookieLangValue = this.languageService.languageCookieValue;
    const token = abp.auth.getToken();

    const requestHeaders = {
      'Abp.TenantId': `${abp.multiTenancy.getTenantIdCookie()}`,
      '.AspNetCore.Culture': `c=${cookieLangValue}|uic=${cookieLangValue}`,
    };

    if (token) {
      Object.assign(requestHeaders, { 'Authorization': `Bearer ${token}` });
    }

    this.httpClient.get<any>(`${this.baseUrl}/AbpUserConfiguration/GetAll`,
      {
        headers: requestHeaders,
      }
    ).subscribe((response) => {
      const result = response.result;

      _merge(abp, result);
      // TODO: refresh components
    });
  }
}
